import React from 'react'
import { Box, Button, Typography } from '@material-ui/core'

/**
 * مرزِ خطای سراسری — اگر رندرِ یک صفحه کرش کند، به‌جای صفحهٔ سفیدِ خالی،
 * پیام خطا و دکمهٔ بازگشت نشان داده می‌شود (و در کنسول هم لاگ می‌شود).
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { error: null }
  }

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidCatch(error, info) {
    // برای دیباگ در کنسول مرورگر
    console.error('UI error:', error, info)
  }

  render() {
    if (this.state.error) {
      const msg = String((this.state.error && this.state.error.message) || this.state.error || '')
      return (
        <Box
          dir="rtl"
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          style={{ minHeight: '100vh', padding: 24, gap: 12, textAlign: 'center' }}
        >
          <Typography variant="h6" style={{ fontWeight: 800 }}>خطای غیرمنتظره در نمایش صفحه</Typography>
          <Typography variant="body2" color="textSecondary" style={{ maxWidth: 640, direction: 'ltr' }}>
            {msg}
          </Typography>
          <Box style={{ display: 'flex', gap: 8 }}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                try { localStorage.removeItem('impersonate_backup') } catch (e) { /* noop */ }
                window.location.href = '/'
              }}
            >
              بازگشت به صفحهٔ اصلی
            </Button>
            <Button variant="outlined" onClick={() => window.location.reload()}>تلاش دوباره</Button>
          </Box>
        </Box>
      )
    }
    return this.props.children
  }
}
